var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderDelivering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 26.9999,
    height: 26.9999,
    rx: 7.49997,
    fill: "#E6F0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1521_22336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4358 3.00001C31.5848 3.00783 34.0466 5.84136 33.7234 9.05065C33.5318 10.9565 32.7633 12.6165 31.7571 14.1835C30.9351 15.4532 29.9791 16.6251 28.9065 17.6777C28.493 18.089 28.371 18.0925 27.9651 17.6862C26.3061 16.0226 24.8802 14.1828 23.918 11.995C23.4356 10.9039 23.133 9.76596 23.1116 8.56123C23.0544 5.52242 25.4784 2.99291 28.4358 3.00001ZM28.431 10.9117C28.9012 10.9101 29.3604 10.7646 29.7503 10.4935C30.1401 10.2225 30.443 9.83817 30.6205 9.38937C30.7981 8.94057 30.8422 8.44752 30.7474 7.97281C30.6525 7.4981 30.423 7.06313 30.0879 6.72313C29.7527 6.38313 29.3271 6.15342 28.8651 6.06316C28.4031 5.9729 27.9254 6.02616 27.4928 6.21619C27.0602 6.40621 26.6922 6.72443 26.4354 7.13044C26.1785 7.53646 26.0446 8.01196 26.0504 8.49659C26.0588 9.14061 26.3131 9.75528 26.7582 10.2074C27.2033 10.6595 27.8033 10.9125 28.4282 10.9117H28.431Z",
    fill: "url(#paint0_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9094 26.0541H9.82697C10.1502 23.8748 11.3391 22.5174 13.3805 21.9072C13.335 21.67 13.2896 21.437 13.2427 21.204C13.1235 20.5725 13.4839 20.115 14.1049 20.1086C14.2944 20.1086 14.484 20.1086 14.6735 20.1086C15.2421 20.1186 15.5998 20.5526 15.5116 21.128C15.4709 21.388 15.4213 21.6465 15.3737 21.9214C16.4847 22.2056 17.3814 22.7951 18.0506 23.7299C18.5381 24.4089 18.8352 25.2129 18.9094 26.0541Z",
    fill: "url(#paint1_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40988 27.7499C9.18352 27.7499 9.00002 27.5664 9.00002 27.34C9.00002 27.1137 9.18352 26.9302 9.40988 26.9302H19.3108C19.5372 26.9302 19.7207 27.1137 19.7207 27.34C19.7207 27.5664 19.5372 27.7499 19.3108 27.7499H9.40988Z",
    fill: "url(#paint2_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3626 15.8812C16.445 15.6592 16.6932 15.5476 16.9139 15.6334L19.2164 16.5284C19.4317 16.6121 19.5396 16.8543 19.4594 17.0709C19.3772 17.2928 19.1297 17.4032 18.9091 17.3175L16.6068 16.424C16.3908 16.3402 16.2821 16.0985 16.3626 15.8812Z",
    fill: "url(#paint3_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8654 11.8004C11.6509 11.7998 11.4689 11.6353 11.4782 11.4209C11.5236 10.3725 12.1348 9.39856 13.0277 8.94552C13.2396 8.838 13.4814 8.96077 13.5545 9.18687C13.6232 9.39953 13.5187 9.63137 13.3279 9.74776C12.7222 10.1173 12.3861 10.6584 12.3086 11.375C12.2835 11.6074 12.0992 11.801 11.8654 11.8004Z",
    fill: "url(#paint4_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0816 18.8816C24.0002 19.105 23.7502 19.2197 23.5286 19.1337L21.2277 18.2402C21.0135 18.1571 20.9049 17.9183 20.9829 17.7022C21.0636 17.4787 21.3126 17.3654 21.5341 17.4516L23.8368 18.3471C24.0505 18.4302 24.1601 18.6662 24.0816 18.8816Z",
    fill: "url(#paint5_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.537 26.0351C25.3109 26.0351 25.1275 25.8517 25.1275 25.6256C25.1275 25.3994 25.3109 25.2161 25.537 25.2161H28.0086C28.2104 25.2161 28.3794 25.3451 28.4105 25.5445C28.4491 25.7928 28.2599 26.0351 28.0085 26.0351H25.537Z",
    fill: "url(#paint6_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6089 9.45376C15.3847 9.45376 15.2029 9.27201 15.2029 9.0478C15.2029 8.8236 15.3847 8.64185 15.6089 8.64185H18.0776C18.3018 8.64185 18.4836 8.8236 18.4836 9.0478C18.4836 9.27201 18.3018 9.45376 18.0776 9.45376H15.6089Z",
    fill: "url(#paint7_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.415 24.7711C30.2833 24.9648 30.0126 24.9676 29.842 24.8072C29.6807 24.6554 29.6637 24.4083 29.7743 24.2164C30.1365 23.5884 30.1809 22.9428 29.8979 22.2668C29.8117 22.061 29.8601 21.8163 30.0407 21.6853C30.2248 21.5519 30.4847 21.5811 30.5941 21.7804C31.0688 22.6455 30.9921 23.9225 30.415 24.7711Z",
    fill: "url(#paint8_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0425 25.2339C23.2687 25.2339 23.4521 25.4172 23.4521 25.6434C23.4521 25.8696 23.2687 26.0529 23.0425 26.0529H20.5857C20.3596 26.0529 20.1762 25.8696 20.1762 25.6434C20.1762 25.4172 20.3596 25.2339 20.5857 25.2339H23.0425Z",
    fill: "url(#paint9_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6244 19.5068C25.7061 19.2841 25.9548 19.1719 26.1759 19.2578L28.4768 20.1524C28.6913 20.2357 28.7993 20.4759 28.7204 20.692C28.6392 20.914 28.3918 21.0258 28.1714 20.9403L25.8691 20.048C25.6537 19.9645 25.5448 19.7238 25.6244 19.5068Z",
    fill: "url(#paint10_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5651 14.7245C14.7764 14.8041 14.875 15.0374 14.7968 15.2492C14.7118 15.4798 14.4509 15.5972 14.2225 15.5065C13.8019 15.3396 13.3912 15.1799 12.9954 14.9885C12.5485 14.7744 12.1964 14.4455 11.9358 14.0094C11.8235 13.8214 11.9123 13.585 12.109 13.4889C12.3192 13.3862 12.5685 13.4853 12.7055 13.6749C13.1525 14.294 13.8795 14.466 14.5651 14.7245Z",
    fill: "url(#paint11_linear_1521_22336)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2052 9.04953C22.2052 9.2755 22.022 9.45869 21.796 9.45869H20.5804C20.3545 9.45869 20.1713 9.2755 20.1713 9.04953C20.1713 8.82357 20.3545 8.64038 20.5804 8.64038H21.796C22.022 8.64038 22.2052 8.82357 22.2052 9.04953Z",
    fill: "url(#paint12_linear_1521_22336)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1521_22336",
    x: 6.00003,
    y: 0.750008,
    width: 30.7519,
    height: 30.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.749997
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.49999
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.239216 0 0 0 0 0.682353 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1521_22336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1521_22336",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1521_22336",
    x1: 24.9102,
    y1: 3.88406,
    x2: 31.5395,
    y2: 15.3749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1521_22336",
    x1: 12.0935,
    y1: 21.1204,
    x2: 18.2809,
    y2: 25.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1521_22336",
    x1: 14.3603,
    y1: 26.9302,
    x2: 14.3603,
    y2: 27.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1521_22336",
    x1: 17.9108,
    y1: 15.4773,
    x2: 17.9108,
    y2: 17.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1521_22336",
    x1: 12.5762,
    y1: 8.7854,
    x2: 12.5762,
    y2: 11.8015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1521_22336",
    x1: 22.5316,
    y1: 17.2944,
    x2: 22.5316,
    y2: 19.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1521_22336",
    x1: 26.8071,
    y1: 25.2161,
    x2: 26.8071,
    y2: 26.0351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1521_22336",
    x1: 16.8432,
    y1: 8.64185,
    x2: 16.8432,
    y2: 9.45376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1521_22336",
    x1: 30.2315,
    y1: 21.449,
    x2: 30.2315,
    y2: 25.0951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1521_22336",
    x1: 21.8141,
    y1: 25.2339,
    x2: 21.8141,
    y2: 26.0529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1521_22336",
    x1: 27.172,
    y1: 19.1013,
    x2: 27.172,
    y2: 21.0959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1521_22336",
    x1: 13.3455,
    y1: 13.3,
    x2: 13.3455,
    y2: 15.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1521_22336",
    x1: 21.1882,
    y1: 8.64038,
    x2: 21.1882,
    y2: 9.45869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C72FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124BDD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDelivering);
export default __webpack_public_path__ + "static/media/order-delivering.960ac57d4a2086a9338ffdb228aee7dc.svg";
export { ForwardRef as ReactComponent };